/* ===========================================================================
   DEV AASTHA — SITE-WIDE BEHAVIOUR            (assets/da-site.js)
   ---------------------------------------------------------------------------
   `layout/theme.liquid` ki line 822 par jodi gayi hai:
       <script src="{{ 'da-site.js' | asset_url }}" defer></script>

   ⚠ `defer` ZAROORI hai — header ki apni inline script se takraana nahi hai.
   ⚠ Har feature `DA.feature()` ke andar rahe: ek ka error baaki sabko na le doobe.
   =========================================================================== */

(function () {
  'use strict';

  var DA = window.DASite = window.DASite || {};

  DA.reduceMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  DA.feature = function (name, fn) {
    try { fn(); }
    catch (e) { if (window.console && console.warn) console.warn('[da-site] ' + name + ' failed:', e); }
  };

  DA.ready = function (fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  };

  /* -------------------------------------------------------------------------
     1) EDD WIDGET — FAIL OPEN
     -------------------------------------------------------------------------
     ASLI WAJAH (`assets/da-pdp-v2-edd.js` me):
         IP_SRC = [ https://ipwho.is/ , https://ipapi.co/json/ ]
         ...country_code === "IN" ... warna hideWidget()
     Widget BAAHRI IP API par tika hai aur FAIL-CLOSED hai — API block/fail/
     rate-limit hua to widget CHHUP jaata hai. Ad blocker, privacy extension,
     VPN, ya free-tier limit — Indian grahak ko bhi widget nahi dikhta.

     ILAAJ: fail OPEN. Store India-only hai (INR, pan-India delivery).
     ⚠ MutationObserver isliye (timer nahi): hide kabhi bhi ho sakta hai.
     ⚠ Purana vyavhaar wapas chahiye to bas ye feature block hata do.
  ------------------------------------------------------------------------- */
  DA.feature('edd-fail-open', function () {
    if (!('MutationObserver' in window)) return;

    var wire = function () {
      var box = document.querySelector('.dapdp .deliv');
      if (!box || box.dataset.daEddOpen === '1') return;
      box.dataset.daEddOpen = '1';

      var unhide = function () {
        if (box.style.display === 'none') box.style.display = '';
      };

      unhide();
      new MutationObserver(unhide).observe(box, { attributes: true, attributeFilter: ['style'] });
    };

    DA.ready(wire);
    setTimeout(wire, 1500);   /* variant badalne par widget dobara aa sakta hai */
  });

  /* -------------------------------------------------------------------------
     2) FOUNDER CARD — "ABOUT THE PRODUCT" SE THEEK UPAR (DONO VIEW)
     -------------------------------------------------------------------------
     Owner (7 Aug 2026): dono view me founder ka placement product ke upar —
     isliye koi breakpoint, koi wapas-le-jaane wala code aur koi resize listener
     nahi chahiye. Jagah ek hi hai, hamesha.

     ⚠ 8 Aug 2026 — JAGAH BADLI. Owner ka kram:
         corporate > craftsmanship > Signature Box > Certificate >
         FOUNDERS > About the Product > FAQ > Customers also viewed
       `.pad` ka pehla bachcha "About the Product" hai — isliye founder ko `.pad`
       ke SABSE UPAR daalna theek wahi kram deta hai. Anchor `.ptabs` hai.

     ⚠⚠ CSS SE MUMKIN NAHI — founder ek ALAG shopify-section hai, aur `order`
       sirf EK container ke bachchon ka kram badalta hai.
     ⚠⚠ `.pad` me daalte hain, `.qarow` me NAHI: desktop par `.qarow` do-column
       GRID hai (naapa 690.5px 690.5px) aur founder FAQ ke bagal me grid cell
       ban jaata tha.
     ⚠ Anchor CLASS se dhoondha jaata hai, index se NAHI.
  ------------------------------------------------------------------------- */
  DA.feature('founder-above-about', function () {
    /* ⚠⚠ THEME EDITOR ME YE SARKAV NAHI CHALTA — YAHI "Broken HTML" KI JAD THI.
       Ye poora `shopify-section` uthakar `.dapdp > .pad` me daalta hai, yani EK
       SECTION DOOSRE KE ANDAR. Editor har section ko `main` ka SEEDHA bachcha
       maanta hai, isliye wo "Broken HTML has been detected" deta hai.
       Markup kabhi toota hi nahi tha — DOM baad me toda ja raha tha:
         shopify theme check -> 0 errors; section re-parse -> 229 in / 229 out.
       ⚠ Editor me founder apni asli jagah dikhega; storefront par nahi badalta. */
    if (window.Shopify && window.Shopify.designMode) return;

    function place() {
      var card = document.querySelector('.dast__card--founder');
      if (!card) return;
      var sec = card.closest('.shopify-section');
      if (!sec) return;

      /* ⚠⚠ `.dapdp > .pad` SE MAT DHOONDHNA — page par DO hain. Pehla
         `sections/da-breadcrumb.liquid` ka hai aur `querySelector` wahi laut
         aata hai; founder ek baar breadcrumb ke bagal chala gaya tha. */
      var mark = document.querySelector('.dapdp .pad .ptabs')      /* About  */
              || document.querySelector('.dapdp .pad .qarow')      /* FAQ    */
              || document.querySelector('.dapdp .pad .dac-grid');  /* related*/
      if (!mark) return;

      var pad = mark.closest('.pad');
      if (!pad) return;

      var anchor = mark;
      while (anchor.parentElement && anchor.parentElement !== pad) anchor = anchor.parentElement;
      if (anchor.parentElement !== pad || anchor === sec) return;

      if (sec.parentElement === pad && sec.nextElementSibling === anchor) return;
      pad.insertBefore(sec, anchor);
    }

    DA.ready(place);

    document.addEventListener('shopify:section:load', function () {
      setTimeout(place, 60);
    });
  });

  /* -------------------------------------------------------------------------
     3) PRODUCT CARD RATING — PDP WALA FORMAT           (owner ask #20–24)
     -------------------------------------------------------------------------
     Card par rating PDP jaisi: 4.9 ★★★★★ (102)

     ⚠⚠ CSS SE NAHI HO SAKTA. `.dac-card` ka markup average CHHAPTA hi nahi, aur
       `content: attr(aria-label)` poori string deta hai — uska tukda nahi.
     ⚠ Sirf `.dac-*` family. Home ka `.pcard` server-side hi sahi hai.
     ⚠ IDEMPOTENT (`data-da-rate`) — collection filter aur related products AJAX
       se badalte hain.
     ⚠ Observer SIRF `.dac-grid` par, `subtree` ke BINA — poore `main` par lagane
       se gallery har DOM badlav par image 1 par kood jaati thi.
  ------------------------------------------------------------------------- */
  DA.feature('card-rating-pdp-format', function () {
    var RE = /([\d.]+)\s*out of 5,\s*(\d+)/i;

    function read(box) {
      var m = RE.exec(box.getAttribute('aria-label') || '');
      if (m) return { avg: parseFloat(m[1]), cnt: parseInt(m[2], 10) };

      var b  = box.querySelector('b');
      var em = box.querySelector('em');
      if (!b || !em) return null;

      var cm = /(\d+)/.exec(em.textContent || '');
      return { avg: parseFloat(b.textContent), cnt: cm ? parseInt(cm[1], 10) : 0 };
    }

    function upgrade(box) {
      if (box.dataset.daRate === '1') return;

      var got = read(box);
      if (!got) return;

      var avg = got.avg, cnt = got.cnt;
      if (!isFinite(avg) || !cnt) return;

      var pct = Math.max(0, Math.min(100, avg * 20));

      box.dataset.daRate = '1';
      box.innerHTML =
        '<b class="rnum">' + avg.toFixed(1) + '</b>' +
        '<span class="sv">' +
          '<span class="bgs">★★★★★</span>' +
          '<span class="fgs" style="width:' + pct.toFixed(2) + '%">★★★★★</span>' +
        '</span>' +
        '<span class="cnt">(' + cnt + ')</span>';
    }

    function run() {
      var boxes = document.querySelectorAll('.dac-card .dac-rating');
      for (var i = 0; i < boxes.length; i++) upgrade(boxes[i]);
    }

    function watch() {
      if (!('MutationObserver' in window)) return;
      var grids = document.querySelectorAll('.dac-grid');
      for (var i = 0; i < grids.length; i++) {
        if (grids[i].dataset.daRateWatch === '1') continue;
        grids[i].dataset.daRateWatch = '1';
        new MutationObserver(run).observe(grids[i], { childList: true });
      }
    }

    DA.ready(function () { run(); watch(); });
    setTimeout(function () { run(); watch(); }, 1200);
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { run(); watch(); }, 60);
    });
  });

  /* -------------------------------------------------------------------------
     4) PRICE ROW — THEME EDITOR ME DOBARA JOD DO
     -------------------------------------------------------------------------
     `sections/da-pdp-v2.liquid` ki inline script DOOSRE section ka DOM hilati
     hai — banaya hua `.pricewrap` `…__main` ke ANDAR baithta hai jabki script
     `…__da_pdp_v2` ki hai. Us script par ek-baar wala taala hai, aur editor
     `main` ko baar-baar re-render karta hai, isliye editor me `.pricewrap`
     banti hi nahi thi aur price CSS (jo usi par scoped hai) gir jaati thi.

     ⚠⚠ YAHAN designMode KA GUARD JAAN-BOOJH KAR NAHI HAI — mat jodna. Ek baar
       joda tha ye maan kar ki banner isi se aata hai; GALAT tha. Banner tabhi
       gaya jab founder-move ko roka. Guard lagane se editor me MRP daam ke
       neeche gir jaata tha aur "Inclusive of all taxes" line gayab ho jaati thi.
  ------------------------------------------------------------------------- */
  DA.feature('price-row-repair', function () {
    function build() {
      var price = document.querySelector('.price-product-container');
      var offer = document.querySelector('[data-da-offer]');
      if (!price || !offer) return;
      if (price.closest('.pricewrap')) return;   /* idempotent — yahi jaan hai */

      var priceHost = price.closest('.shopify-block') || price.parentElement;
      var offerHost = offer.closest('.shopify-block') || offer.parentElement;
      if (!priceHost || !priceHost.parentNode) return;

      var host = document.createElement('div');
      host.className = 'dapdp';
      var row = document.createElement('div');
      row.className = 'pricewrap';
      host.appendChild(row);

      priceHost.parentNode.insertBefore(host, priceHost);
      priceHost.classList.add('da-pw-price');
      offerHost.classList.add('da-pw-offer');
      row.appendChild(priceHost);
      row.appendChild(offerHost);
    }

    function sweep() {
      document.querySelectorAll('.pricewrap').forEach(function (row) {
        if (row.querySelector('.price-product-container')) return;
        var host = row.parentElement;
        row.remove();
        if (host && host.classList.contains('dapdp') && !host.children.length) host.remove();
      });
    }

    DA.ready(function () { sweep(); build(); });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { sweep(); build(); }, 120);
    });
  });

  /* -------------------------------------------------------------------------
     5) STICKY ATC + WHATSAPP        — spec PDP-03 / PDP-04 / PDP-05
     -------------------------------------------------------------------------
     WHY THIS REPLACES THE OLD LOGIC. `assets/da-pdp-v2.js` still carries:
         bar.classList.toggle("is-away", !down || y <= 240);
     That is SCROLL DIRECTION, not CTA visibility. Measured on 375x812 with the
     primary CTA at y 683-728:

       scroll    is-away  bar     CTA in view?  spec wants  result
       0         yes      hidden  yes           hidden      ok
       600 down  no       SHOWN   yes           hidden      FAIL, covers live CTA
       1400 down no       shown   no            shown       ok
       700 up    yes      HIDDEN  no            shown       FAIL, gone when needed
       100 up    yes      hidden  yes           hidden      ok

     Two of four fail, and both failures are inherent to using direction as a
     proxy for visibility — no threshold tuning fixes them.

     ⚠⚠ THE OLD LISTENER IS STILL RUNNING. `da-pdp-v2.js` is 40 KB of generated
       code and themeFilesUpsert replaces whole files, so it was not edited.
       Instead THE CSS NO LONGER REACTS TO `is-away` — it reacts to
       `da-atc-show`, which only this code sets. Do NOT re-point the CSS at
       `is-away`: the two would fight on every scroll event.

     PDP-04 (product-agnostic) is satisfied BY CONSTRUCTION — the observer
     measures wherever the CTA actually lands. Not one pixel offset in here.
  ------------------------------------------------------------------------- */
  DA.feature('sticky-atc-cta-visibility', function () {
    if (!('IntersectionObserver' in window)) return;   /* leave old behaviour */

    function init() {
      var bar = document.querySelector('.dapdp .sticky');
      if (!bar || bar.dataset.daAtcBound === '1') return;
      bar.dataset.daAtcBound = '1';

      /* ⚠⚠ THE OBSERVED CTA MUST NOT BE THE ONE INSIDE THE STICKY BAR.
         `.btn--atc` matches TWICE — buy column and the bar itself. Observing the
         bar's own copy makes it observe itself: show -> visible -> hide, forever.
         Measured: the real primary CTA is Ella's `.product-form__submit`. */
      var cta = null;
      var cands = document.querySelectorAll('.dapdp .btn--atc, .product-form__submit');
      for (var i = 0; i < cands.length; i++) {
        if (!cands[i].closest('.sticky')) { cta = cands[i]; break; }
      }
      if (!cta) return;

      var footer = document.querySelector('[id*="da_footer"]') || document.querySelector('footer');
      var ctaVisible = true, footerVisible = false;

      function apply() {
        var show = !ctaVisible && !footerVisible;
        bar.classList.toggle('da-atc-show', show);
        /* ⚠ offsetHeight, NOT getBoundingClientRect(): the bar carries a
           translateY when hidden. offsetHeight is transform-independent. */
        var h = show ? bar.offsetHeight : 0;
        var root = document.documentElement.style;
        root.setProperty('--da-atc-h', h + 'px');
        root.setProperty('--da-wa-bottom', (show ? h + 12 : 16) + 'px');
      }

      new IntersectionObserver(function (es) {
        ctaVisible = es[es.length - 1].isIntersecting; apply();
      }, { threshold: 0 }).observe(cta);

      if (footer) {
        new IntersectionObserver(function (es) {
          footerVisible = es[es.length - 1].isIntersecting; apply();
        }, { threshold: 0 }).observe(footer);
      }

      /* ⚠ Cannot feed back: apply() only writes a transform and two custom
         properties on <html>; neither changes the bar's own box. */
      if ('ResizeObserver' in window) new ResizeObserver(apply).observe(bar);

      apply();
    }

    DA.ready(init);
    document.addEventListener('shopify:section:load', function () {
      setTimeout(init, 80);
    });
  });

  /* -------------------------------------------------------------------------
     6) SIZE GUIDE — LOADER OF LAST RESORT           (owner, 9 Aug 2026)
     -------------------------------------------------------------------------
     THE PREFERRED PATH IS LIQUID: `snippets/da-sizeguide-assets.liquid`,
     rendered from `blocks/da-delivery.liquid`. That path uses `asset_url`, so
     every URL carries its own `?v=` hash. THIS code is the backstop for the
     case where no block on the page renders that snippet — which is exactly
     what happened on 11 Aug 2026 and hid every size-guide image.

     ⚠⚠ THE TWO LISTS MUST MATCH. The snippet loads five files; so does this.
       Change one, change the other. The 11 Aug bug WAS the mismatch: this
       loader was missing `-icons.js` and `-images.js`, so the sheet fell
       through to its OWN inline fallbacks — `REF` with mm + label but NO image
       url, and the single `SILO.idol` arch — giving the right
       "DEBIT CARD / 8.6 cm / 5.4 cm" numbers, a generic arch instead of the
       Kamdhenu / elephant cut-out, and `<image href="undefined">`, which iOS
       Safari paints as its blue broken-image placeholder.

     ⚠⚠ `async = false` IS LOAD-BEARING. A script created with
       `document.createElement` is ASYNC BY DEFAULT and `defer` does NOT apply
       to it — appended scripts would execute in whatever order they finish
       downloading. `icons` and `images` define `DASizeGuideIcons` /
       `DASizeGuideRefs` / `DASizeGuidePickImage` and MUST run before the sheet,
       so `async = false` is what restores insertion order. Do not remove it,
       and do not reorder the array.

     ⚠⚠ KNOWN LIMITATION OF THIS PATH — the URLs it builds have NO `?v=` hash,
       and Shopify's CDN serves unversioned asset URLs with long cache headers.
       Measured once: a `cache: 'no-store'` fetch still returned the previous
       build. So while the page is running on THIS loader, edits to the size
       guide files may not appear for a while. That is a second reason to keep
       the delivery block in `templates/product.json` rather than leaning on
       this. It is a safety net, not the design.

     ⚠ Loads ONLY when `[data-da-sg-data]` is present, which
       `blocks/da-variant-picker.liquid` emits solely on a PDP with a rendered
       picker — so single-variant products and every non-PDP page cost nothing.
     ⚠ The button does not call anything here — the picker block dispatches
       `da:sizeguide:open`, and the sheet listens. That indirection keeps the
       variant picker working even if this widget fails to load.
  ------------------------------------------------------------------------- */
  DA.feature('size-guide-loader', function () {
    DA.ready(function () {
      if (!document.querySelector('[data-da-sg-data]')) return;
      if (document.querySelector('[data-da-sg-asset]')) return;

      if (window.console && console.warn) {
        console.warn('[da-site] size guide: Liquid loader did not render — ' +
                     'falling back to unversioned asset URLs. Check that the ' +
                     '"DA · Delivery" block is still on the product template.');
      }

      var base = (function () {
        /* derive the theme asset base from any already-loaded da- asset */
        var l = document.querySelector('link[href*="/assets/da-"], script[src*="/assets/da-"]');
        var u = l && (l.href || l.src);
        return u ? u.replace(/\/assets\/da-[^/]*$/, '/assets/') : null;
      })();
      if (!base) return;

      /* same five files as snippets/da-sizeguide-assets.liquid, same order */
      ['da-pdp-v2-sizeguide.css',
       'da-pdp-v2-sizeguide-fill.css'].forEach(function (f) {
        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = base + f;
        css.setAttribute('data-da-sg-asset', '1');
        document.head.appendChild(css);
      });

      ['da-pdp-v2-sizeguide-icons.js',
       'da-pdp-v2-sizeguide-images.js',
       'da-pdp-v2-sizeguide.js'].forEach(function (f) {
        var js = document.createElement('script');
        js.src = base + f;
        js.async = false;        /* see the note above — this is the ordering fix */
        js.defer = true;
        js.setAttribute('data-da-sg-asset', '1');
        document.head.appendChild(js);
      });
    });
  });

  DA.ready(function () {
    document.documentElement.classList.add('da-site-ready');
  });
})();
